<template>
    <div class="cz2__mariners--header">
        <funko-logo class="hide--below-xl" />

        <pop-view-toggle
            v-if="isReviewStep"
            class="cz2__toggle-mariners"
        />

        <main-navigation class="cz2__main-navigation-wrapper" />

        <img
            src="../assets/images/pop-yourself-logo.svg"
            alt="Pop! Yourself Logo"
            class="cz2__mariners-pop-logo hide--below-xl"
        >
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2.cz2__is-mariners {
        .cz2__mariners--header {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;

            .cz2__funko-logo-wrapper {
                position: static;
                padding-top: var(--layout-spacing);
                display: flex;
                justify-content: center;
            }

            .cz2__mariners-pop-logo {
                width: auto !important;
                height: 92px !important;
            }

            .cz2__toggle-mariners {
                z-index: 1;
                order: 2;
            }

            .cz2__main-navigation-button-content {
                white-space: nowrap;
            }

            @include respond-above(xl) {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                align-items: flex-start;

                .cz2__funko-logo-wrapper {
                    margin: 0;
                    padding: 0;
                    justify-self: flex-start;
                }

                .cz2__main-navigation-wrapper {
                    justify-self: center;
                }

                .cz2__mariners-pop-logo {
                    justify-self: flex-end;
                }

                .cz2__toggle-mariners {
                    position: absolute;
                    left: var(--layout-spacing);
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
</style>

<script>
    import FunkoLogo from './FunkoLogo.vue';
    import MainNavigation from './MainNavigation.vue';
    import PopViewToggle from './PopViewToggle.vue';

    export default {
        components: {
            FunkoLogo,
            MainNavigation,
            PopViewToggle,
        },

        computed: {
            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            isReviewStep() {
                return this.currentGroup?.code === 'Review';
            },
        },
    };
</script>
